import keycloak from "../keycloak";

export const ensureFreshToken = async (minValiditySeconds = 30) => {
  if (!keycloak?.authenticated) {
    return null;
  }

  try {
    await keycloak.updateToken(minValiditySeconds);
    return keycloak.token || null;
  } catch (error) {
    console.error("Failed to refresh Keycloak token", error);
    return keycloak.token || null;
  }
};

export const getAuthHeaders = async (extraHeaders = {}) => {
  const token = await ensureFreshToken();
  const headers = {
    ...extraHeaders,
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return headers;
};
